<template>
    <v-dialog v-model="show" transition="dialog-top-transition" :class="`custom-sheet-dialog ${customclass}`"
        :width="width">
        <template v-slot:default>
            <v-card :class="`mx-auto custom-sheet pb-1 ${customclass}`">
                <v-card-item class="dialog-title-container pa-0">

                    <v-card-title class="pa-3">
                        <slot v-if="$slots.title" name="title">
                        </slot>
                        <template v-else>
                            <div class="d-flex align-center w-100">
                                <v-icon @click="closeSheet" icon="mdi-close" size="x-small" />
                                <div class="flex-grow-1">
                                    <span class="flex-grow-1 text-center">{{ title }}</span>
                                </div>
                            </div>
                        </template>

                    </v-card-title>
                </v-card-item>
                <!-- Customizable content -->
                <v-card-text class="custom-sheet-content px-0 pb-0 ">
                    <div class="pa-4" name="default">
                        <slot></slot>
                    </div>
                </v-card-text>
                <v-divider class="my-0" v-if="$slots.actions"></v-divider>
                <v-card-actions v-if="$slots.actions">
                    <slot v-if="$slots.actions" name="actions">
                    </slot>
                </v-card-actions>
            </v-card>
            <!-- Close button -->
        </template>
    </v-dialog>
</template>

<script>
export default {
    name: "CustomSheet",
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        width: {
            type: Number,
            default: 900,
        },
        title: {
            type: String,
            default: null,
        },
        customclass: {
            type: String,
        }
    },
    computed: {
        show: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    methods: {
        closeSheet() {
            this.show = false;
        },
    },
};
</script>

<style>
.custom-sheet-dialog {
    display: flex !important;
    justify-content: center !important;
    /* Align content at the top */
    align-items: flex-start !important;
}

.custom-sheet-dialog ::-webkit-scrollbar {
    width: 10px;
}

/* Track */
.custom-sheet-dialog ::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #f3f3f3;
}

/* Handle */
.custom-sheet-dialog ::-webkit-scrollbar-thumb {
    background: rgb(117.5, 117.5, 117.5);
    border-radius: 10px;
}

/* Handle on hover */
.custom-sheet-dialog ::-webkit-scrollbar-thumb:hover {
    background: rgb(117.5, 117.5, 117.5);
}

.custom-sheet {
    width: 100%;
    background-color: white;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    overflow: hidden;
    padding: 16px;
    position: relative;
}

.custom-sheet-content {
    max-height: 80vh;
    /* Set the maximum height of the scrollable area */
    overflow-y: auto;
    /* Enable vertical scrolling */
}

.close-btn {
    position: absolute;
    top: 8px;
    right: 8px;
}

.dialog-title-container {
    border-bottom: 1px solid #ddd;
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
}

.v-overlay__content {
    margin-top: 0px !important;
    /* 
    position: relative;
    margin-left:auto !important;
    margin-right:auto !important;
    */
}

.v-overlay__scrim {
    opacity: 0.5 !important;
}
</style>